
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
import cssToObjectMixin from '~/mixins/cssToObject'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin, cssToObjectMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },

  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)

      // styles.background = `url(${this.blok?.image?.filename}) no-repeat center center`

      return styles
    },
    imageStyles() {
      const styles = {}

      const imgUrl = this.$img(this.blok.image?.filename, {
        format: 'webp',
        loading: 'lazy',
      })
      styles.background = `url('${imgUrl}') no-repeat center center`
      styles.backgroundSize = 'cover'

      return styles
    },
    overlayStyles() {
      const styles = {}

      const imgUrl = this.$img(this.blok.imageOverlay?.filename, {
        format: 'webp',
        loading: 'lazy',
      })
      styles.background = `url('${imgUrl}') no-repeat center center`
      styles.backgroundSize = 'cover'

      return styles
    },
  },

  methods: {
    onHover() {
      this.$gsap.to(this.$refs.contentContainer, {
        duration: 0.5,
        yPercent: 50,
        ease: 'power2.out',
      })

      this.$gsap.to(this.$refs.overlay, {
        duration: 0.5,
        opacity: 0,
        ease: 'power2.out',
      })

      this.$gsap.to(this.$refs.image, {
        duration: 0.5,
        scale: 1,
      })

      this.$gsap.to(this.$refs.content, {
        duration: 0.4,
        yPercent: 75,
        opacity: 0,
        scale: 1.1,
      })
      this.$gsap.to(this.$refs.contentReveal, {
        duration: 0.5,
        opacity: 1,
        scale: 1,
      })
    },
    onLeave() {
      this.$gsap.to(this.$refs.contentContainer, {
        duration: 0.5,
        yPercent: 0,
        ease: 'power2.out',
      })
      this.$gsap.to(this.$refs.overlay, {
        duration: 0.5,
        opacity: 1,
        overwrite: true,
        ease: 'power2.out',
      })

      this.$gsap.to(this.$refs.image, {
        duration: 0.5,
        scale: 1.2,
      })

      this.$gsap.to(this.$refs.content, {
        duration: 0.5,
        yPercent: 0,
        opacity: 1,
        scale: 1,
      })
      this.$gsap.to(this.$refs.contentReveal, {
        duration: 0.5,
        opacity: 0,
        scale: 0.8,
      })
    },
  },
}
